<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-service-form modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>บันทึกรายการบริการของร้าน</span>
                        </h4>

                        <button class="btn-close" @click="hide(false)"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form" v-if="formData && errorData">
                            <div class="row">
                                <div class="col-12">
                                    <div class="field">
                                        <label>หัวข้อบริการ</label>
                                        <dropdown
                                            v-model="selectedServiceTopic"
                                            placeholder="-- หัวข้อบริการ --"
                                            :options="option.serviceTopic"
                                            :classes="{ input: ['input-field', (errorData.serviceTopic.blank ? 'invalid' : '')] }"
                                            @change="changeServiceTopic($event)"
                                        ></dropdown>
                                        <input type="text" 
                                            class="input-field mt-2"
                                            :class="{ 'invalid': errorData.serviceTopic.blank }"
                                            maxlength="100"
                                            placeholder="หัวข้อบริการ"
                                            v-show="selectedServiceTopic === '-'"
                                            v-model="formData.serviceTopic" />
                                        <div class="input-error-message" v-if="errorData.serviceTopic.blank">โปรดกรอกหัวข้อบริการ</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <div class="field">
                                        <label>ราคาเริ่มต้น</label>
                                        <input type="tel" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.price.blank }"
                                                maxlength="6"
                                                placeholder="ราคาเริ่มต้น"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.price" />
                                        <div class="input-error-message" v-if="errorData.price.blank">โปรดกรอกราคาเริ้มต้น</div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 text-right">
                                <button class="btn btn-main" @click="saveStoreService()">บันทึก</button>
                                <button class="btn btn-grey-outline" @click="hide(false)">ปิด</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import DBStoreService from '@/database/StoreService';
import OptionServiceTopic from '@/database/staticOption/ServiceTopic';

export default {
    data() {
        return {
            isActive: false,
            selectedServiceTopic: '',
            formData: null,
            errorData: null,
            option: {
                serviceTopic: []
            }
        };
    },
    props: {
        isDisplay: Boolean,
        keyData: [Number, String]
    },
    mounted() {
        this.initOptionData();
    },
    watch: {
        async isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.formData = await this.initFormData();
                this.errorData = this.initValidateData();
            }
        }
    },
    methods: {
        hide(isReload) {
            this.$emit('hide', isReload);
        },
        async initFormData() {
            let data = null;

            if (this.keyData) {
                data = await DBStoreService.getDetail(this.keyData);
            }

            return this.mapViewData(data);
        },
        mapViewData(data) {
            return {
                key: data ? data.key : '',
                serviceTopic: data ? data.serviceTopic : '',
                price: data ? data.price : ''
            }
        },
        async initOptionData() {
            this.option.serviceTopic = OptionServiceTopic.option;
        },
        initValidateData() {
            return {
                serviceTopic: { blank: false },
                price: { blank: false }
            }
        },
        changeServiceTopic(value) {
            if (value === '-') {
                this.formData.serviceTopic = '';
            } else {
                this.formData.serviceTopic = value;
            }
        },
        async saveStoreService() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();

                await DBStoreService.save(this.formData);

                this.hide(true);
                loader.hide();
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (!this.formData[property].trim()) {
                    this.errorData[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-service-form {
    max-width: 600px;
}
</style>